import { getData, getLayout } from "./plotUtils";

import { VALUE_TYPE } from "Components/NumberValue";
import { useWindowSize } from "Utils/screenSizeUtils";
import React from "react";
import Plot from "react-plotly.js";
import { getPlotConfig } from "../plotConfig";
import { AdviceWrapper } from "../styled";

export interface AdvicePlotCriticalIllnessProps {
  income: number;
  payout: number;
  valueType: VALUE_TYPE;
  advicePlot: any;
  lang: string;
  range?: number[];
}

export const AdvicePlotCriticalIllness = (
  props: AdvicePlotCriticalIllnessProps,
): React.ReactElement => {
  const windowSize = useWindowSize();
  const mobileVariant = windowSize.width ? windowSize.width < 540 : false;

  const config = getPlotConfig();
  const layout = getLayout(props, mobileVariant, windowSize);
  const data = getData(props);

  return (
    <AdviceWrapper
      className="AdvicePlot"
      marginBottom={mobileVariant ? "6px" : undefined}
    >
      <Plot config={config} layout={layout} data={data} />
    </AdviceWrapper>
  );
};
